import { render, staticRenderFns } from "./FooterMain.vue?vue&type=template&id=474a17b2&scoped=true&"
import script from "./FooterMain.vue?vue&type=script&lang=js&"
export * from "./FooterMain.vue?vue&type=script&lang=js&"
import style0 from "./FooterMain.vue?vue&type=style&index=0&id=474a17b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a17b2",
  null
  
)

export default component.exports